import Vue from 'vue'
import VueSocketio from 'vue-socket.io'
import io from 'socket.io-client'
import store from './../store'
import AppConfig from './config/AppConfig'

const GLOBAL_CONFIG = AppConfig.load()

Vue.use(
  new VueSocketio({
    debug: true,
    connection: io(GLOBAL_CONFIG.SOCKET_SERVER, { path: '/api/socket.io' }),
    vuex: {
      store,
      actionPrefix: 'SOCKET_',
      mutationPrefix: 'SOCKET_',
    },
  })
)
